import {Injectable, OnDestroy} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable, Subscription} from 'rxjs';
import {FormatConfigService} from "../core/services/format-config.service";
import {ErweiterungConfigResponse} from "../core/base-api";
import {SecurityData} from "./security-data";
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

@Injectable({
  providedIn: 'root'
})
export class ErweiterungGuard implements CanActivate, OnDestroy {

  private subscription: Subscription;

  /*
   * Hack to prevent compile error: _ERROR in TypeError: Cannot read property 'loadChildren' of undefined_
   * See: https://github.com/angular/angular/issues/22700
   */
  static routeConfig(erweiterung: ActiveErweiterungenEnum[]): ActiveErweiterungenEnum[] {
    return erweiterung;
  }

  constructor(private formatConfigService: FormatConfigService, private router: Router, private securityData: SecurityData) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise<boolean>(resolve => {
      this.subscription = this.formatConfigService.initialized$.subscribe(() => {
        const erweiterung: ActiveErweiterungenEnum[] = route.data.erweiterung;
        if (erweiterung && !erweiterung.some(e => this.formatConfigService.erweiterungsConfig.activeErweiterungen.includes(e))) {
          this.securityData.actionUrl = state.url;
          this.securityData.erweiterung = erweiterung;
          this.router.navigate(['security/unsupported']);
          resolve(false);
        }
        resolve(true);
      });
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

}
